<template>
  <div id="report-request">
    <div class="card">
      <div class="card-header border-0">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="mb-0">{{ $t(this.$route.name + '.reportRequestTitle') }}</h4>
          </div>
        </div>
      </div>

      <div class="card-body" id="card-body-custom">
        <div class="row">
          <div class="col">
            <v-date-picker class="inline-block h-full" mode="date" v-model="reportDate" :locale="getUserLanguage()"
              :max-date="getYesterday()">
              <template v-slot="{ inputValue, togglePopover }">
                <div class="flex items-center">
                  <a type="button" style="padding: 10px;" @click="togglePopover()">
                    <i class="ni ni-calendar-grid-58"></i>
                  </a>
                  <input :value="inputValue"
                    class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                    v-on:focus="togglePopover()"
                    readonly />
                </div>
              </template>
            </v-date-picker>
          </div>

          <div class="col">
            <button v-if="!requestOnGoing" class="btn btn-icon btn-primary" v-on:click="requestReport()">{{
              $t(this.$route.name + '.reportRequestDownloadButton')
            }}</button>
            <button v-else class="btn btn-icon btn-primary disabled">
              <div class="row">
                <div class="col-sm-1"><div class="spinner-border spinner-border-sm text-light" role="status"></div></div>
                <div class="col">{{ $t(this.$route.name + '.reportRequestWaitingForResponse') }}...</div>
              </div>
            </button>
          </div>
        </div>
        <div class="row" v-if="error_msg != ''">
          <div class="col">
            <span style="color:red;">
              {{ error_msg }}
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import useVuelidate from '@vuelidate/core'
import ReportService from '@/services/report.service.js'

export default {
  name: "report-request",
  setup() {
    return { v$: useVuelidate() }
  },
  props: {
    terrain_id: String
  },
  validations() {
    return {}
  },
  created() {
    var landlord = JSON.parse(localStorage.getItem("landlord"));
    this.landlord = landlord;
  },
  data() {
    return {
      reportDate: this.getYesterday(),
      error_msg: '',
      requestOnGoing: false,
    }
  },
  methods: {
    getUserLanguage() {
      return this.$i18n.locale;
    },
    getYesterday() {
      let date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    requestReport() {
      this.requestOnGoing = true;
      ReportService.getReportByTerrainId(this.landlord.id, this.terrain_id, this.reportDate.toISOString().substring(0, 10)).then((response) => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = this.reportDate.toISOString().substring(0, 10) + '_' + this.terrain_id + '.pdf'
        link.click()
        this.requestOnGoing = false;
      }, (error) => {
        if (error.response.status == 404) {
          this.error_msg = this.$t(this.$route.name + '.reportRequestTerrainNoModules');
        }
      })
    }
  }
};
</script>
<style>
.divider {
  font-size: 1px;
  background: rgba(0, 0, 0, 0.5);
}
</style>
